import { HttpRequest, HttpHandlerFn } from '@angular/common/http';

let NO_CACHE_EXTENSIONS = [".json", ".css"];

/**
 * Intercepts HTTP requests from Angular and applies a "nocache" request parameter
 * to ensure the request will be unique
 * Reference: http://overengineer.net/preventing-angularjs-from-caching-your-templates-and-other-files
 */
export const noCacheInterceptor = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  if (NO_CACHE_EXTENSIONS.some((extension) => request.url.endsWith(extension))) {
     request = request.clone({
       url: getNoCacheUrl(request.url),
     });
   }
   return next(request);
 }

const getNoCacheUrl = (requestUrl: string) => {
  let newRequestUrl: string = requestUrl;

  // Calculate the current minute to 4 digits
  //  ~~ to do a Math.floor
  let paramNumber = ~~(Date.now() / 60000) % 10000;

  newRequestUrl += (requestUrl.indexOf('?') !== -1) ? '&' : '?';
  newRequestUrl += "nocache=" + paramNumber;

  return newRequestUrl;
}
